import React from 'react';
import { PricingPageProps } from './types';
import './styles.scss';
import { SUBSCRIPTIONS_ENABLED } from '../../types';

const PricingPage: React.FC<PricingPageProps> = ({ setCurrentPage }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Pricing</h1>
        <p>Choose the plan that fits your needs</p>
      </div>

      <div className="pricing-grid">
        <div className="pricing-card">
          <div className="pricing-badge">Free</div>
          <h3>Starter</h3>
          <div className="price">
            <span className="price-amount">$0</span>
            <span className="price-period">/month</span>
          </div>
          <ul className="pricing-features">
            <li>20 credits on signup</li>
            <li>Basic satellite data</li>
            <li>Community sharing</li>
            <li>Email support</li>
          </ul>
          <button className="btn btn-secondary btn-large">Current Plan</button>
        </div>

        <div className="pricing-card featured">
          <div className="pricing-badge-featured">Popular</div>
          <h3>Professional</h3>
          <div className="price">
            <span className="price-amount">$1</span>
            <span className="price-period">/month</span>
          </div>
          <ul className="pricing-features">
            <li>100 credits per month</li>
            <li>Advanced satellite data</li>
            <li>Priority processing</li>
            <li>API access</li>
            <li>24/7 support</li>
          </ul>
          {SUBSCRIPTIONS_ENABLED ? (
            <button onClick={() => setCurrentPage('billing')} className="btn btn-primary btn-large">Upgrade Now</button>
          ) : (
            <button className="btn btn-secondary btn-large" disabled>Currently Unavailable</button>
          )}
        </div>

        <div className="pricing-card">
          <div className="pricing-badge">Enterprise</div>
          <h3>Enterprise</h3>
          <div className="price">
            <span className="price-amount">Custom</span>
          </div>
          <ul className="pricing-features">
            <li>Unlimited analyses</li>
            <li>All satellite data sources</li>
            <li>Dedicated infrastructure</li>
            <li>Custom integrations</li>
            <li>SLA guarantee</li>
            <li>Dedicated support</li>
          </ul>
          <button className="btn btn-secondary btn-large">Contact Sales</button>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
